import { Stack } from 'src/components/Stack';

import { CustomBlockingReason } from './CustomBlockingReason';
import { PaymentRequiredReason } from './PaymentRequiredReason';
import { CheckinBlockerUser } from './_types';

export function BlockingReasonList({
  blockers,
  inlineActions = false,
  userId,
}: {
  blockers: CheckinBlockerUser['blockers'];
  inlineActions?: boolean;
  userId: string;
}) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      {blockers.map((blocker, index) => {
        const key = `${blocker.type}-${index}`;
        switch (blocker.type) {
          case 'billing_blocked':
            return (
              <PaymentRequiredReason
                key={key}
                userId={userId}
                inlineActions={inlineActions}
              />
            );
          case 'waiver_required':
          default:
            return (
              <CustomBlockingReason
                key={key}
                message={blocker.message}
              />
            );
        }
      })}
    </Stack>
  );
}
